var MdmLink = () => import('~/components/atoms/MdmLink.vue');
export default {
  name: 'NavItemFlat',
  components: {
    MdmLink
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  }
};